<ng-container *ngIf="flags.length; else noActiveFlags">
    <table mat-table class="active-flags-table" [dataSource]="flags">
        <ng-container matColumnDef="category">
            <th *matHeaderCellDef mat-header-cell scope="col">Category</th>
            <td *matCellDef="let element" mat-cell>
                <span class="active-flags-table__category">
                    <svg aria-hidden="true" fill="none" viewBox="0 0 15 15">
                        <path
                            d="M0.0195312 11.8799V0.819336H9.33011L7.34926 3.95738L9.33011 7.08711H1.4487V11.8799H0.0195312Z"
                            [attr.fill]="element?.categoryColor"
                        />
                    </svg>
                    {{ element.category | uppercase }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="followUpTime">
            <th *matHeaderCellDef mat-header-cell scope="col">Follow up</th>
            <td *matCellDef="let element" mat-cell>
                <ng-container *ngIf="element.followUpTime">
                    <div class="active-flags-table__date" [class.active-flags-table__date--overdue]="element.isPassedDue">
                        <span>{{ element.followUpTime | date: 'HH:mm' }} {{ element.timezone }}</span>
                        <span>{{ element.followUpTime | date: 'MM/dd/yyyy' }}</span>
                        <ng-container *ngIf="element.isPassedDue">
                            <app-ds-badge icon="schedule" label="Overdue" size="sm" theme="error"></app-ds-badge>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="!element.followUpTime">
                    <div class="active-flags-table__date active-flags-table__date--none">
                        <span>No follow up</span>
                        <span>Created {{ element.createdOn | date: 'HH:mm' }} {{ element.timezone }}</span>
                        <span>{{ element.createdOn | date: 'MM/dd/yyyy' }}</span>
                    </div>
                </ng-container>
            </td>
        </ng-container>

        <ng-container matColumnDef="reason">
            <th *matHeaderCellDef mat-header-cell scope="col">Description</th>
            <td *matCellDef="let element" mat-cell>
                <span class="active-flags-table__clamp" [title]="element.reason">{{ element.reason }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell scope="col">
                <span class="active-flags-table__actions-header">Actions</span>
            </th>
            <td *matCellDef="let element" mat-cell>
                <div class="active-flags-table__actions">
                    <ds-button label="Edit follow up" size="sm" theme="tertiary-gray" (buttonClick)="editFlag.emit(element)"></ds-button>
                    <ds-button label="Resolve" size="sm" theme="secondary" (buttonClick)="resolveFlag.emit(element)"></ds-button>
                </div>
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row [class.active-flags-table__row--overdue]="row.isPassedDue"></tr>
    </table>
</ng-container>

<ng-template #noActiveFlags>
    <div class="active-flags-table__empty">
        <ds-icon name="flag" size="lg" theme="tertiary"></ds-icon>
        <ds-text
            size="sm"
            theme="secondary"
            text="You have no active flags yet. Add a flag to track follow ups on this service request."
        ></ds-text>
    </div>
</ng-template>
